/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_SelectedInputs */

const cs_picker_selected = /** @type {(inputs: Picker_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybráno`)
};

const en_picker_selected = /** @type {(inputs: Picker_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Picker_SelectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const picker_selected = /** @type {((inputs?: Picker_SelectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_SelectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_picker_selected(inputs)
	return cs_picker_selected(inputs)
});